import { create } from 'zustand';

interface States {
  quidgetId: string;
  quidgetLoading: boolean;
}

interface Actions {
  setQuidgetId: (id: States['quidgetId']) => void;
  setQuidgetLoading: (id: States['quidgetLoading']) => void;
}

export const useQuidgetStore = create<States & Actions>((set) => ({
  quidgetId: '',
  quidgetLoading: false,

  setQuidgetId: (id) => set(() => ({ quidgetId: id })),
  setQuidgetLoading: (isLoading) => set(() => ({ quidgetLoading: isLoading })),
}));
